import { render } from "./last-alarms.vue?vue&type=template&id=df571932&scoped=true"
import script from "./last-alarms.vue?vue&type=script&lang=js"
export * from "./last-alarms.vue?vue&type=script&lang=js"

import "./last-alarms.vue?vue&type=style&index=0&id=df571932&lang=scss&scoped=true"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df571932"]])

export default __exports__